/**
 * deviceType设备类型
 */

export default {
  CR: 'CR1510,CR1600,CR1600E,CR1600II,CR2000,CR3000',
  EF: 'EF1000,EF2000',

  // FCBR系列
  FCBR_100_v1: 'FCBRv1',
  FCBR_100_v2: 'FCBR-100',
  FCBR_100B: 'FCBR-100B',
  FCBR_100PRO: 'FCBR-100PRO',
  FCBR_100F: 'FCBR-100F',
  FCBR_100G: 'FCBR-100G',
  FCBR_100CP: 'FCBR-100CP',
  FCBR_100C: 'FCBR-100C',
  FCBR_100CV2: 'FCBR-100CV2',
  FCBR_100S1: 'FCBR-100S1',
  FCBR_100M: 'FCBR-100M',
  FCBR100_N: 'FCBR-100N',
  FCBR_100GA: 'FCBR-100GA',
  FCBR_100PROGA: 'FCBR-100PROGA',
  FCBR_100CFR: 'FCBR-100CFR',

  CR2500: 'CR2500',
  B02_V2: 'BM3001', // bm4000
  BM3001: 'BM3001',

  Chem_Pro_100: 'ChemPro100', // HT设备
  Chem_Pro_FXi: 'ChemProFXi',
  AC200: 'AC200',
  AC1000: 'AC1000',

  BC500: 'BC500',

  BU_10: 'BU-10',
  BU10: 'BU10',
  J171: 'J171',
  RG_500: 'RG500', // RG500
  NGP_2: 'NGP-2',
  VP_100: 'VP100',
  VP_200: 'VP200',
  PID_IndApp: 'PID-IndApp',
  Gemini_N: 'Gemini-N',
  RS_500: 'RS500',
  FIT_RM: 'fitRM',
  CIAE_RMS_E: 'CIAE-RMS-E',
  CIAE_RMS_C: 'CIAE-RMS-C',
  GD_606: 'GD606',
  GD_611: 'GD611',
  GD_612: 'GD612',
  GD_624: 'GD624',
  GM_602: 'GM602',
  GM_606: 'GM606',
  CD_603: 'CD603',
  CD_602: 'CD602',
  MN_606: 'MN606',
  FR_01: 'FD102IR3-HC',

  RG_05: 'RG05',

  // 火焰检测仪
  SJA310: 'SJA310',

  // HT系列
  HT01: 'HT01',
  HT100: 'HT100',
  HT200: 'HT200',
  HT300: 'HT300',

  ZX27: 'ZX27',

  CT1226: 'CT1226',

  // 122设备
  WIRELESSBOX: 'WIRELESSBOX',
  NRHM01: 'NRH-M01',
  PMS6003: 'PMS6003',
  RFQF01: 'RFQF01',

  CR1224: 'CR1224', //核
  CRA1221: 'CRA1221', //核

  CB1223: 'CB1223', // 生
  CB12231: 'CB12231', // 生

  // 053 无人机
  CR0534: 'CR0534',
  CR05341: 'CR05341',

  //  天津消防
  PTQXZ: 'PTQXZ',
  GW1021: 'GW1021',
  GW1034M: 'GW1034M',
  GW1041: 'GW1041',

  EFM100: 'EFM100',
  RM1000: 'RM1000'
};
